import React, { useEffect, useState } from 'react';
import { getApi } from '../../services/api';

const Team = () => {
  const [myteam, setMyteam] = useState([]);
  const [levelData, setLevelData] = useState([]);
  const [tabaleView, setTableview] = useState('directTeam');
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  const getTeamdata = async () => {
    setTableLoading(true);
    try {
      const response = await getApi('my-referral');
      if (response.data?.status === true || response.status === true) {
        setMyteam(response.data?.data || response.data);
      } else {
        setMyteam([]);
      }
      setTableview('directTeam');
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setTableLoading(false);
    }
  };

  useEffect(() => { getTeamdata(); }, []);

  const getlevelData = async () => {
    setTableLoading(true);
    try {
      const response = await getApi('my-team');
      if (response.data?.status === true || response.status === true) {
        setLevelData(response.data.data || response.data);
      } else {
        setLevelData([]);
      }
      setTableview('levelTeam');
    } catch (error) {
      console.error(error);
    } finally {
      setTableLoading(false);
    }
  };

  const getTreeData = async () => {
    setTableview('treeTeam');
  };

  const tabs = [
    { id: 'directTeam', label: 'Direct Team', icon: 'bi-people', action: getTeamdata },
    // { id: 'levelTeam', label: 'Level Team', icon: 'bi-diagram-3', action: getlevelData },
    { id: 'treeTeam', label: 'Tree View', icon: 'bi-share', action: getTreeData },
  ];

  const statsCards = [
    { label: 'Direct Referrals', value: myteam?.direct_referral || 0, icon: 'bi-person-plus', color: 'green' },
    { label: 'Total Team', value: myteam?.total_team || 0, icon: 'bi-people', color: 'blue' },
    { label: 'Left Users', value: myteam?.left_team || 0, icon: 'bi-arrow-left-circle', color: 'yellow' },
    { label: 'Right Users', value: myteam?.right_team || 0, icon: 'bi-arrow-right-circle', color: 'purple' },
  ];

  return (
    <div className="page-wrapper">
      {/* Header */}
      <div className="page-header mb-4">
        <div className="section-label">Network</div>
        <h2 className="page-title">My Team</h2>
        <p className="page-subtitle">Monitor and grow your referral network</p>
      </div>

      {/* Stats Cards */}
      <div className="row g-3 mb-4">
        {statsCards.map((card, i) => (
          <div key={i} className="col-md-3 col-6">
            {loading ? (
              <div className="skeleton" style={{ height: 90, borderRadius: 18 }}></div>
            ) : (
              <div className={`metric-card ${card.color}`}>
                <div className={`metric-icon ${card.color}`}><i className={`bi ${card.icon}`}></i></div>
                <div>
                  <div className="metric-label">{card.label}</div>
                  <div className="metric-value">{card.value}</div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Binary Balance Bar */}
      {!loading && (myteam?.left_team > 0 || myteam?.right_team > 0) && (
        <div className="p-card mb-4">
          <p className="section-label">Binary Balance</p>
          <div className="row g-3">
            <div className="col-md-6">
              <div className="p-progress-wrap">
                <div className="p-progress-header">
                  <span className="p-progress-label">Left Branch</span>
                  <span className="p-progress-value">{myteam?.left_team || 0} members</span>
                </div>
                <div className="p-progress">
                  <div className="p-progress-bar" style={{
                    width: `${Math.min(((myteam?.left_team || 0) / Math.max((myteam?.total_team || 1), 1)) * 100, 100)}%`
                  }}></div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="p-progress-wrap">
                <div className="p-progress-header">
                  <span className="p-progress-label">Right Branch</span>
                  <span className="p-progress-value">{myteam?.right_team || 0} members</span>
                </div>
                <div className="p-progress">
                  <div className="p-progress-bar" style={{
                    width: `${Math.min(((myteam?.right_team || 0) / Math.max((myteam?.total_team || 1), 1)) * 100, 100)}%`,
                    background: 'linear-gradient(90deg, var(--page-blue), var(--page-purple))'
                  }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tabs + Table */}
      <div className="p-card">
        {/* Tab Buttons */}
        <div className="p-tabs">
          {tabs.map(tab => (
            <button key={tab.id} className={`p-tab ${tabaleView === tab.id ? 'active' : ''}`}
              onClick={tab.action}>
              <i className={`bi ${tab.icon}`}></i>
              {tab.label}
            </button>
          ))}
        </div>

        {/* Table Area */}
        {tableLoading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-success mb-2"></div>
            <p style={{ color: 'var(--text-secondary)' }}>Loading team data...</p>
          </div>
        ) : (
          <>
            {/* Direct Team */}
            {tabaleView === 'directTeam' && (
              <>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 style={{ margin: 0, fontWeight: 700 }}>Direct Referrals</h5>
                  <span style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>{myteam?.list?.length || 0} members</span>
                </div>
                {!myteam?.list?.length ? (
                  <div className="empty-state">
                    <div className="empty-icon"><i className="bi bi-person-plus"></i></div>
                    <h6>No Direct Referrals Yet</h6>
                    <p>Share your referral code to grow your team</p>
                  </div>
                ) : (
                  <div className="p-table-wrap">
                    <table className="p-table">
                      <thead>
                        <tr><th>#</th><th>User Code</th><th>Stake Status</th><th>Join Date</th></tr>
                      </thead>
                      <tbody>
                        {myteam.list.map((item, i) => (
                          <tr key={item.id}>
                            <td className="dim">{i + 1}</td>
                            <td>
                              <span className="u-code">
                                {item.my_code?.slice(0, 6)}••••{item.my_code?.slice(-4)}
                              </span>
                            </td>
                            <td>
                              <span className={`s-pill ${item.stake_status === 'Active' ? 'active' : 'inactive'}`}>
                                {item.stake_status || 'Inactive'}
                              </span>
                            </td>
                            <td className="dim" style={{ fontSize: '0.82rem' }}>
                              {new Date(item.created_at).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            )}

            {/* Level Team */}
            {tabaleView === 'levelTeam' && (
              <>
                <h5 style={{ marginBottom: '1rem', fontWeight: 700 }}>Level Distribution</h5>
                {!levelData?.levelCounts || Object.keys(levelData.levelCounts).length === 0 ? (
                  <div className="empty-state">
                    <div className="empty-icon"><i className="bi bi-diagram-3"></i></div>
                    <h6>No Level Data</h6>
                    <p>Grow your team to unlock level rewards</p>
                  </div>
                ) : (
                  <div className="row g-2">
                    {Object.entries(levelData.levelCounts).map(([level, count]) => (
                      <div key={level} className="col-md-4 col-6">
                        <div style={{ background: 'rgba(255,255,255,0.03)', borderRadius: 14, padding: '1rem', border: '1px solid rgba(255,255,255,0.07)', textAlign: 'center', transition: 'all 0.2s' }}>
                          <div style={{ fontSize: '0.72rem', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 700, marginBottom: 4 }}>Level {level}</div>
                          <div style={{ fontSize: '1.6rem', fontWeight: 800, fontFamily: 'JetBrains Mono, monospace', color: 'var(--page-accent)' }}>{count}</div>
                          <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>members</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}

            {/* Tree View */}
            {tabaleView === 'treeTeam' && (
              <>
                <h5 style={{ marginBottom: '1.5rem', fontWeight: 700 }}>Network Tree</h5>
                <div style={{ overflowX: 'auto', paddingBottom: '1rem' }}>
                  {/* You (Root) */}
                  <div className="text-center mb-4">
                    <div className="tree-node root d-inline-block">
                      <div style={{ fontSize: '1.5rem', marginBottom: 4 }}>👤</div>
                      <div className="tn-label">YOU</div>
                      <div className="tn-value" style={{ color: 'var(--page-accent)' }}>Root</div>
                    </div>
                  </div>

                  {/* Connection Line */}
                  <div style={{ width: 2, height: 30, background: 'rgba(0,255,149,0.3)', margin: '0 auto' }}></div>

                  {/* L/R Branches */}
                  <div className="row g-4 justify-content-center">
                    <div className="col-md-5">
                      <div className="tree-node text-center">
                        <i className="bi bi-arrow-left-circle" style={{ color: 'var(--page-warning)', fontSize: '1.2rem', display: 'block', marginBottom: 4 }}></i>
                        <div className="tn-label">Left Branch</div>
                        <div className="tn-value" style={{ color: 'var(--page-warning)' }}>{myteam?.left_team || 0}</div>
                        <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>members</div>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="tree-node text-center">
                        <i className="bi bi-arrow-right-circle" style={{ color: 'var(--page-purple)', fontSize: '1.2rem', display: 'block', marginBottom: 4 }}></i>
                        <div className="tn-label">Right Branch</div>
                        <div className="tn-value" style={{ color: 'var(--page-purple)' }}>{myteam?.right_team || 0}</div>
                        <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>members</div>
                      </div>
                    </div>
                  </div>

                  <div style={{ marginTop: '1.5rem', padding: '1rem', background: 'rgba(255,255,255,0.02)', borderRadius: 12, border: '1px solid rgba(255,255,255,0.06)', textAlign: 'center' }}>
                    <p style={{ margin: 0, color: 'var(--text-secondary)', fontSize: '0.85rem' }}>
                      <i className="bi bi-info-circle me-2"></i>
                      Total network: <strong style={{ color: 'white' }}>{myteam?.total_team || 0}</strong> members across{' '}
                      <strong style={{ color: 'white' }}>{Object.keys(levelData?.levelCounts || {}).length || '—'}</strong> levels
                    </p>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Team;